import React from 'react'
import "../../Styles/About/About.css"
function About({ tagline, about, skills, tools, handleRobotText }) {
  return (
    <section id="about" className="about">
      <div className="aboutContainer flexBox">
        <h1>About Me</h1>
        <div className="aboutBox flexBox">
          <q>{tagline}</q>
          <p>{about}</p>
        </div>
        <h1>Skills</h1>
        <div
          className="skillsContainer flexBox"
          onMouseEnter={() => handleRobotText("He has good Skills...")}
        >
          {skills.map((skill) => (
            <div key={skill.title} className="skillBox glass light flexBox">
              <img src={skill.image} alt="logo" />
              <p>{skill.title}</p>
            </div>
          ))}
        </div>
        <h1>Tools</h1>
        <div
          className="skillsContainer flexBox"
          onMouseEnter={() => handleRobotText("He has good Skills...")}
        >
          {tools.map((tool) => (
            <div key={tool.title} className="skillBox glass light flexBox">
              <img src={tool.image} alt="logo" />
              <p>{tool.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About
